import React, { useEffect, useState } from "react";
import Common from "Common";
import { Line, MLabel, Title, GoodsImg } from "./styles";
import goodsApi from "api/goodsApi";
import DialogFormSearch from "components/DialogFormSearch";
import { Box } from "@mui/material";
import GoodsImgDefault from "assets/images/goods_default.jpg";


const SelectClientGoods = ({ open, handleSelected, handleClose, setIsLoading, setMessage }) => {
  const [termClientGoods, setTermClientGoods] = useState({ txtSearch: '' });
  const [dtGoods, setDtGoods] = useState([]);


  useEffect(() => {
    (async function SearchGoods() {
      try {
        setIsLoading(true);
        /**Call Api */
        const params = {
          txtSearch: termClientGoods?.txtSearch || '',
        }
        const dtResponse = await goodsApi.getClientGoods(params);
        const dt = dtResponse?.data['dtGoods'] ?? [];
        setDtGoods(dt);
      } catch (err) {
        const msg = {
          contents: [err],
          type: Common.MESSAGE.ERROR
        }
        setMessage(msg);
      } finally {
        setIsLoading(false);
      }
    })();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [termClientGoods, termClientGoods.txtSearch])

  const renderGoodsItem = (item) => {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <GoodsImg src={!!item?.GoodsImageUrl ? item?.GoodsImageUrl : GoodsImgDefault} alt="image" />
        <Box sx={{ ml: 1 }}>
          <Title >{item.GoodsName}</Title>
          <Line>
            <MLabel>サイズ：</MLabel>{item.GoodsSize || '―'}
          </Line>
        </Box>
      </Box >)
  }

  return (
    <>
      <DialogFormSearch
        open={open}
        title={`商品を選択してください`}
        textHolder={`商品名`}
        termSearch={termClientGoods}
        setTermSearch={setTermClientGoods}
        resultList={dtGoods}
        renderItem={renderGoodsItem}
        selectItem={handleSelected}
        classNameCss={'pl-20'}
        handleClose={handleClose}
      />
    </>);
};

export default SelectClientGoods;
